import React from 'react';
import {
  Container,
  Button,
  Navbar,
  NavbarBrand,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import {
  FaUserCircle,
  FaSignOutAlt,
  FaChevronDown,
  FaHome
} from 'react-icons/fa';
import Swal from 'sweetalert2';
import { authActions } from '../sagas/authSlice';
import logo from '../assets/images/logoh.png';

const LegacyLayout = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { fullName, businessName } = useSelector(state => state.auth);

  const handleLogout = () => {
    Swal.fire({
      title: t('auth.logoutConfirmTitle'),
      text: t('auth.logoutConfirmText'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(authActions.logout());
        Swal.fire({
          icon: 'success',
          title: t('auth.logoutSuccess'),
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          navigate('/login');
        });
      }
    });
  };

  return (
    <div className="legacy-layout-wrapper min-vh-100 bg-light">
      {/* Top Navigation Bar */}
      <Navbar className="bg-white shadow-sm" expand="lg">
        <Container fluid>
          {/* Left side - Logo */}
          <NavbarBrand className="d-flex align-items-center">
            <img
              src={logo}
              alt="MatjarPos"
              height="35"
              className="me-2"
            />
            <div>
              <div className="fw-bold text-primary">{businessName}</div>
            </div>
          </NavbarBrand>

          {/* Center - Back to modules button */}
          <div className="mx-auto">
            <Button
              color="outline-primary"
              size="sm"
              onClick={() => navigate('/modules')}
            >
              <FaHome className="me-1" size={14} />
              {t('navigation.modules')}
            </Button>
          </div>

          {/* Right side - User Menu */}
          <div className="d-flex align-items-center">
            <UncontrolledDropdown>
              <DropdownToggle nav className="d-flex align-items-center text-dark text-decoration-none">
                <FaUserCircle size={20} className="me-2" />
                <span className="me-1 d-none d-lg-inline">{fullName}</span>
                <FaChevronDown size={12} />
              </DropdownToggle>
              <DropdownMenu end className="shadow">
                <DropdownItem header>
                  <small className="text-muted">
                    {t('user.signedInAs')}<br />
                    <strong>{fullName}</strong>
                  </small>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => navigate('/modules')}>
                  <FaHome className="me-2" /> {t('navigation.modules')}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={handleLogout}>
                  <FaSignOutAlt className="me-2" /> {t('user.signOut')}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </Container>
      </Navbar>

      {/* Main Content */}
      <main className="flex-grow-1">
        <Container fluid className="p-4">
          {children}
        </Container>
      </main>
    </div>
  );
};

export default LegacyLayout;
